module.exports = __webpack_public_path__ + "static/img/icon-1.78b3a23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-2/icon-1.png
// module id = zC9b
// module chunks = 0